import { ThemeLayoutType } from './Theme.context';

export const DEFAULT_THEME_LAYOUT: ThemeLayoutType = {
  sidebar: {
    compact: undefined,
  },
};